<template>
    <div class="com-codics-hbb-order-admin-goods-order-body">
        <div class="com-codics-hbb-order-admin-goods-order-bar-content">
            <el-cascader class="com-codics-hbb-order-admin-goods-order-bar-pick" v-model="goodsType" placeholder="请选择分类"
                :options="typeOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-cascader class="com-codics-hbb-order-admin-goods-order-bar-pick" v-model="goodsBrand" placeholder="请选择品牌"
                :options="brandOptions" :props="{ checkStrictly: true }" clearable
                @change="handleTypeChange"></el-cascader>
            <el-select v-model="goodsTag" multiple collapse-tags style="float:left;margin-right:15px;"
                placeholder="请选择标签" filterable clearable @change="listGoodssFuc">
                <el-option v-for="item in tagsOptions" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-goods-order-bar-input" v-model="searchTxt" placeholder="请输入商品信息..."
                clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="searchGoodss">&#xe86e;
            </MyButton>
            <MyButton style="float: right;" @click.native="jumpToPage('添加商品', {}, {})">&#xe632; 添加商品</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的商品数据（包括销售参数）吗？" @confirm="deleteGoodssFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
            <MyButton style="float: right;margin-right: 15px;padding:0 15px;">&#xe854;</MyButton>
        </div>
        <div class="com-codics-hbb-order-admin-goods-order-bar-content com-codics-hbb-order-admin-goods-order-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                @selection-change="handleSelectionChange">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="com-codics-hbb-order-admin-goods-order-item-box" v-for="(item, index) in props.row.info"
                            :key="index">
                            <div class="com-codics-hbb-order-admin-goods-order-item-card">
                                <div class="com-codics-hbb-order-admin-goods-order-item-card-line">
                                    <el-image class="com-codics-hbb-order-admin-goods-order-item-card-line-img"
                                        :src="'https://cdn.bosscaigou.com/' + item.img"></el-image>
                                    <div class="com-codics-hbb-order-admin-goods-order-item-card-line-text"
                                        :title="item.title">
                                        {{ item.title }}
                                        <el-tag
                                            style="position:relative;float:right;top:50%;transform:translateY(-50%);"
                                            size="mini" :type="item.state == 0 ? 'success' : 'danger'">{{ item.state ==
                                                0 ? '上架' : '下架'
                                            }}</el-tag>
                                    </div>
                                    <div
                                        class="com-codics-hbb-order-admin-goods-order-item-card-line-text com-codics-hbb-order-admin-goods-order-item-card-line-text2">
                                        原价：<del>￥{{ item.op }}</del>
                                    </div>
                                    <div
                                        class="com-codics-hbb-order-admin-goods-order-item-card-line-text com-codics-hbb-order-admin-goods-order-item-card-line-text2">
                                        现价：￥{{ item.np }}
                                    </div>
                                </div>
                                <div class="com-codics-hbb-order-admin-goods-order-item-card-line2">
                                    <span style="float:left;width:50%;" :title="item.remark">备注:{{ item.remark }}</span>
                                    <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="top"
                                        width="160" trigger="hover">
                                        <div class="com-codics-ui-sidebar-menu-item-child"
                                            v-for="(item, index) in ['编辑', '删除']" :key="index" v-html="item"
                                            @click="handleMenuClick(item)"></div>
                                        <div class="iconfont com-codics-hbb-order-admin-goods-order-item-card-more-btn"
                                            slot="reference">
                                            &#xe866;
                                        </div>
                                    </el-popover>
                                    <span style="float:right;width:calc(50% - 35px);text-align:right;"
                                        :title="initTime(item.ctime)">{{ initTime(item.ctime)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="com-codics-hbb-order-admin-goods-order-item-box" style="width:160px;">
                            <div
                                class="com-codics-hbb-order-admin-goods-order-item-card com-codics-hbb-order-admin-goods-order-item-card2">
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="50">
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80">
                </el-table-column>
                <el-table-column prop="title" label="商品名称" width="110">
                </el-table-column>
                <el-table-column prop="detail" label="商品介绍" width="150">
                </el-table-column>
                <el-table-column prop="himg" label="商品封面" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.himg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.himg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="dimg" label="详情图片" width="150">
                    <el-carousel slot-scope="scope" height="70px" width="150px" indicator-position="none">
                        <el-carousel-item v-for="(item, index) in scope.row.dimg.split(',')" :key="index">
                            <el-image style="width: 100%; height: 100%" :src="'https://cdn.bosscaigou.com/' + item"
                                fit="cover"
                                :preview-src-list="scope.row.dimg.split(',').map(item2 => 'https://cdn.bosscaigou.com/' + item2)"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </el-table-column>
                <el-table-column prop="video" label="商品视频" width="90">
                    <template slot-scope="scope">
                        <el-button v-show="scope.row.video != ''" type="primary" size="mini"
                            @click="playVideo(scope.row.video)">播放</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="tip" label="购买须知" width="110">
                </el-table-column>
                <el-table-column prop="origin" label="产地" width="110">
                </el-table-column>
                <el-table-column prop="type" label="商品分类" width="110">
                    <template slot-scope="scope">
                        <el-tag disable-transitions size="mini">{{
                            scope.row?.type }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="70"
                    :filters="[{ text: '上架', value: 0 }, { text: '下架', value: 1 }]" :filter-method="stateFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.state == 0 ? '上架'
                            : '下架' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ts" label="包邮" width="70"
                    :filters="[{ text: '包邮', value: 0 }, { text: '不包邮', value: 1 }]" :filter-method="tsFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ts == 0 ? 'success' : 'danger'" disable-transitions size="mini">{{
                            scope.row.state == 0 ? '包邮'
                            : '不包邮' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="tt" label="物流方式" width="80">
                    <template slot-scope="scope">
                        {{ wuliuType[scope.row.tt] }}
                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" width="180">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前商品数据（包括销售参数）吗？" @confirm="deleteGoodssFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要重置当前用户密码为123456吗？" @confirm="repassGoodssFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small"
                                style="float: right;margin-right: 10px;" slot="reference">编辑
                            </MyButton>
                        </el-popconfirm>
                        <MyButton v-show="scope.row.url != ''" size="small" style="float: right;margin-right: 10px;"
                            slot="reference">详情
                        </MyButton>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40, 100]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import { addGoods, deleteGoods, updateGoods, listGoods, listGoodsBrand, listGoodsType, listTags } from '@/api';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            typeOptions: [],
            brandOptions: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            goodsType: [],
            goodsBrand: [],
            tagsOptions: [],
            goodsTag: [],
            wuliuType: {
                'shunfeng': '顺丰快递',
                'zhongtong': '中通快递',
                'yuantong': '圆通快递',
                'shentong': '申通快递',
                'jtexpress': '极兔快递',
                'yunda': '韵达快递',
                'jd': '京东快递',
                'ems': '邮政快递',
                'qitafangshi': '其他方式'
            }
        }
    },
    components: {
        MyButton
    },
    mounted() {

        this.listGoodssFuc();

        this.listGoodsBrandFuc();

        this.listGoodsTypeFuc();

        this.listTagsFuc();

    },
    methods: {
        async listTagsFuc() {
            const data = await listTags();
            if (data.code == 200) {
                this.tagsOptions = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listGoodssFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listGoodssFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        addGoodsCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodssFuc();

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goodsType.length == 0 ? 0 : this.goodsType[this.goodsType.length - 1],
                brand: this.goodsBrand.length == 0 ? 0 : this.goodsBrand[this.goodsBrand.length - 1],
                tags: this.goodsTag
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteGoods({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listGoodssFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listGoodssFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleTypeChange() {
            this.listGoodssFuc();
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        tsFilter(v, r, c) {

            return r.ts === v;

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-goods-order-body {
    /* height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px; */
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-hbb-order-admin-goods-order-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-order-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-goods-order-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-goods-order-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-order-item-box {
    height: 155px;
    width: 360px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
    display: flex;
}

.com-codics-hbb-order-admin-goods-order-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    transition: .3s;
    background: #F9F9F9;
    border: 1px solid #DDD;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-item-card-line {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-order-item-card-line::before {
    content: '';
    height: 1px;
    width: calc(100% - 20px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-img {
    height: 80px;
    width: 80px;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text {
    height: 30px;
    width: calc(100% - 80px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    transition: .3s;
    line-height: 30px;
    font-size: 11px;
    font-weight: bolder;
    color: #333;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text .el-tag {
    font-size: 9px;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text2 {
    height: 25px;
    line-height: 25px;
    color: #999;
}

.com-codics-hbb-order-admin-goods-order-item-card-line2 {
    height: 35px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 35px;
    font-size: 11px;
    font-weight: bolder;
    color: #666;
    padding-left: 10px;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-order-item-card-more-btn {
    height: 35px;
    width: 35px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 35px;
    text-align: center;
    font-size: 11px;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-order-item-card2 {
    border: 1px dashed #666;
    border-radius: 8px;
    transition: .3s;
    background: transparent;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-item-card2::before,
.com-codics-hbb-order-admin-goods-order-item-card2::after {
    content: '';
    height: 1px;
    width: 25px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: .3s;
    background: #666;
}

.com-codics-hbb-order-admin-goods-order-item-card2::after {
    transform: rotate(90deg);
}
</style>